<template>
    <section class="home-container">
        <MasterPage title="健康咨询">
            <div slot="title-icon">
                <Icon type="ios-contact" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="8">
                        <FormItem label="患者用户：">
                            <Select v-model="select.userId" filterable clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">{{ item.name }} - {{item.phone}}</Option>
                            </Select>
                            <!--<Input placeholder="请输入" v-model="select.userName"/>-->
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="时间段：">
                            <DatePicker v-model="select.dataTime" clearable type="datetimerange" placeholder="请选择时间段" style="width: 100%"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="8">
                        <FormItem label="处理状态：">
                            <Select v-model="select.isHandled" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">未处理</Option>
                                <Option value="true" >已处理</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" style="margin: 0 5px" icon="md-add" @click="addNewItem">发起会话</Button>
                <Button type="primary" style="margin: 0 5px" icon="md-add" @click="sendSMS">短信提醒</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="getMessageUser">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="handleModel" title="留言处理" @on-cancel="cancelItem">
            <Form :label-width="100">
                <FormItem label="患者：">
                    <span v-if="item.id == infoItem.userId" v-for="item in userAllList" :key="item.id">{{item.name}}</span>
                </FormItem>
                <FormItem label="留言：">
                    {{handle.content}}
                </FormItem>
                <FormItem label="回复：">
                    <Input v-model="handle.reply" type="textarea" :autosize="{minRows:3,maxRows: 5}"placeholder="请输入。。。" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="handleLoading" @click="handleItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="留言详情" @on-cancel="cancelItem">
            <Form :label-width="100">
                <Col span="24">
                <div class="info_backgroup">
                    <div class="info_html" id="messageContent">
                        <p style="text-align: center;">
                            <span @click="getMessageByUser" v-if="messagePages > messagePageNum - 1" class="my_complete" >查看更多消息</span>
                            <span v-else class="my_complete" >没有更多消息了</span>
                        </p>
                        <div v-for="(message, index) in messageList" :key="index">
                            <Row type="flex" v-if="message.fromId != null && message.fromId != 0 && message.createTime != null">
                                <div style="display: flex;flex-direction: column;align-items: center">
                                    <Avatar style="border: 2px solid #fff" icon="ios-person"
                                            size="large"/>
                                    <span style="max-width: 40px">{{message.sendName}}</span>
                                </div>
                                <Row type="flex" align="middle">
                                    <div style="margin-left: 5px;max-width: 170px;
                                    background-color: rgb(12,101,194); color: white;padding: 5px;border-radius: 5px;
                                    word-wrap : break-word">{{message.message}}</div>
                                </Row>
                            </Row>
                            <Row type="flex" justify="center" v-if="message.fromId != null && message.fromId != 0 && message.createTime != null"
                                 style="margin-bottom: 5px">
                                <div>{{moment(message.createTime).format('YYYY-MM-DD hh:mm:ss')}}</div>
                            </Row>
                            <Row type="flex" justify="end" v-if="message.fromId != null && message.fromId == 0 && message.createTime != null">
                                <Row type="flex" align="middle">
                                    <div style="margin-left: 5px;max-width: 170px;
                                    background-color: rgb(16,124,45); color: white;padding: 5px;border-radius: 5px;
                                    word-wrap : break-word">{{message.message}}</div>
                                </Row>
                                <div style="display: flex;flex-direction: column;align-items: center">
                                    <Avatar style="border: 2px solid #fff" icon="ios-person"
                                            size="large"/>
                                    <span style="max-width: 40px">{{message.sendName}}</span>
                                </div>
                            </Row>
                            <Row type="flex" justify="center" v-if="message.fromId != null && message.fromId == 0 && message.createTime != null"
                                 style="margin-bottom: 5px">
                                <div>{{moment(message.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
                            </Row>
                        </div>
                    </div>
                    <Row type="flex">
                        <Input placeholder="请输入" v-model="replyMessage.content" style="width: 202px"/>
                        <Button type="primary" style="margin-left: 5px" @click="sendMessage">发送</Button>
                    </Row>
                </div>
                </Col>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
            </div>
        </Modal>
        <Modal v-model="smsModal" title="短信提醒" @on-cancel="closeSMSModal">
            <Form :label-width="100">
                <FormItem label="患者用户：">
                    <Select v-model="smsUserId" remote filterable clearable placeholder="请选择" @on-clear="getSMSUserByPinyin()">
                        <Option v-for="item in smsUserAllList" :value="item.id" :key="item.id" :label="item.name">{{ item.name }} - {{ item.phone }}</Option>
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="closeSMSModal">取消</Button>
                <Button type="primary" size="large" :loading="smsLoading" @click="confirmSendSMS">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import Moment from 'moment'
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                moment: Moment,
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '用户患者',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key: 'sendName'
                    },
                    {
                        title: '留言内容',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        key: 'message'
                    },
                    {
                        title: '留言时间',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let value = params.row.createTime
                            if (value==undefined || value.length <=0)return
                            let time = new Date(value)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hh = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h('span', y+'-'+m+'-'+d+' '+hh+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            if (params.row.flag){
                                return h('span', '已处理')
                            }else{
                                return h('span', '未处理')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true,
                        render: (h, params) => {
                            let Buttons = []
                            if (!params.row.isHandled) {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-alert',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                if (this.currentUser == null || this.currentUser.loginName == null ||
                                                    this.currentUser.loginName == ''){
                                                    this.$Notice.error({title:'请重新登录'})
                                                    return
                                                }
                                                this.replyMessage.fromId = 0
                                                this.replyMessage.sendName = this.currentUser.realName
                                                this.replyMessage.toId = this.dataList[params.index].fromId
                                                this.replyMessage.content = ''
                                                this.infoItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '处理')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'ios-list-box',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                if (this.currentUser == null || this.currentUser.loginName == null ||
                                                    this.currentUser.loginName == ''){
                                                    this.$Notice.error({title:'请重新登录'})
                                                    return
                                                }
                                                this.replyMessage.fromId = 0
                                                this.replyMessage.sendName = this.currentUser.realName
                                                this.replyMessage.toId = this.dataList[params.index].fromId
                                                this.replyMessage.content = ''
                                                this.infoItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '详情')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                userAllList:[],
                smsUserAllList:[],
                tempSMSUserAllList:[],
                tableLoading:false,
                handleModel:false,
                handleLoading:false,
                infoModel:false,
                smsModal:false,
                smsLoading:false,
                select:{
                    userId: null,
                    userName:'',
                    dataTime:'',
                    isHandled:'false',
                },
                smsUserId: null,
                handle:'',
                infoItem:{},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                currentUser: JSON.parse(sessionStorage.getItem('currentUser')),
                messageList: [
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'bbbbbbbbbbbbbbbbbbbbbbbb',
                        replyTime: '2020-02-20 09:30:03'
                    },
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'ccccccccccccccccccccccccc',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'dddddddddddddddddddddd',
                        replyTime: '2020-02-20 09:30:03'
                    },
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'bbbbbbbbbbbbbbbbbbbbbbbb',
                        replyTime: '2020-02-20 09:30:03'
                    },
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'ccccccccccccccccccccccccc',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'dddddddddddddddddddddd',
                        replyTime: '2020-02-20 09:30:03'
                    },
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'bbbbbbbbbbbbbbbbbbbbbbbb',
                        replyTime: '2020-02-20 09:30:03'
                    },
                    {
                        patientId: '1',
                        patientName: 'taaa',
                        patientContent: 'ccccccccccccccccccccccccc',
                        patientTime: '2020-02-20 09:30:03',
                        replyId: '2',
                        replyName: 'admin',
                        replyContent: 'dddddddddddddddddddddd',
                        replyTime: '2020-02-20 09:30:03'
                    }
                ],
                replyMessage: {
                    fromId: '',
                    sendName: '',
                    toId: '',
                    content: ''
                },
                messagePageNum: 1,
                messagePageSize: 10,
                messagePages: 1
            }
        },
        created(){
//            this.pageFindItem()
            this.getMessageUser()
            this.findAllUser()
        },
        methods:{
            sendSMS(){
                this.smsUserId = this.select.userId ? this.select.userId : null
                this.smsUserAllList = this.tempSMSUserAllList && this.tempSMSUserAllList.length > 0 ? JSON.parse(JSON.stringify(this.tempSMSUserAllList)) : JSON.parse(JSON.stringify(this.userAllList || []))
                this.smsModal = true
            },
            closeSMSModal(){
                this.smsModal = false
                this.smsLoading = false
                this.smsUserId = null
            },
            getSMSUserByPinyin(value){
                this.smsUserAllList = JSON.parse(JSON.stringify(this.tempSMSUserAllList || this.userAllList || []))
            },
            confirmSendSMS(){
                if (!this.smsUserId){
                    return this.$Message.warning('请选择患者用户')
                }
                this.smsLoading = true
                this.$http.post('user/newMessageRemind',{ userId: this.smsUserId }).then(function (res) {
                    this.smsLoading = false
                    let msg = res.body
                    if (msg.success){
                        this.$Notice.success({title:'短信提醒已发送'})
                        this.closeSMSModal()
                    }else{
                        this.$Notice.error({title:'发送失败',desc: msg.message})
                    }
                },function (res) {
                    this.smsLoading = false
                    this.myError(res.body)
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                        this.tempSMSUserAllList = JSON.parse(JSON.stringify(msg.data.list))
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageChange(value){
                this.pageNum = value
                // this.pageFindItem()
                this.getMessageUser()
            },
            pageSizeChange(value){
                this.pageSize = value
                // this.pageFindItem()
                this.getMessageUser()
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('message/list',{
                    userId:this.select.userId == undefined ? "": this.select.userId,
                    startTime:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    endTime:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    isHandled:this.select.isHandled,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'患者留言列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            getMessageUser () {
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.messagePageNum = 1
                this.$http.post('message/getLatestMessageByUser',{
                    userId: this.select.userId ? this.select.userId : null,
                    startTime:this.select.dataTime[0] == undefined || this.select.dataTime[0] == "" ? new Date(undefined):this.select.dataTime[0]+"",
                    endTime:this.select.dataTime[1] == undefined || this.select.dataTime[1] == "" ? new Date(undefined):this.select.dataTime[1]+"",
                    flag: this.select.isHandled,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                    type: '健康咨询'
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'患者留言列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.handleModel = this.handleLoading = this.infoModel = false
                this.messagePages = 1
                this.messagePageNum = 1
                this.messageList = []
            },
            handleItem_modal(item){
                this.infoItem['userId']= item.userId
                this.handle = JSON.parse(JSON.stringify(item))
                this.handle['reply'] = ''
                this.handleModel = true
            },
            // 发起留言
            addNewItem () {
                if (this.currentUser == null || this.currentUser.loginName == null ||
                    this.currentUser.loginName == ''){
                    this.$Notice.error({title:'请重新登录'})
                    return
                }
                if (this.select.userId == null || this.select.userId === '') {
                    this.$Notice.error({title:'请先选择患者'})
                    return
                }
                this.replyMessage.fromId = 0
                this.replyMessage.sendName = this.currentUser.realName
                this.replyMessage.toId = this.select.userId
                this.replyMessage.content = ''
                this.infoItem_modal(this.replyMessage)
            },
            handleItem(){
                if (this.handle.reply.length <= 0){
                    return this.$Message.warning('请输入回复信息');
                }
                this.handleLoading = true
                this.$http.post('message/handle',{
                    id:this.handle.id,
                    reply:this.handle.reply,
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '患者留言回复成功'});
                        this.getMessageUser()
                    }else {
                        this.$Notice.error({title:'患者留言回复失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            sendMessage () {
                if (this.replyMessage.content == null || this.replyMessage.content === ''){
                    return this.$Message.warning('请输入回复信息');
                }
                this.handleLoading = true
                this.$http.post('message/sendMessage',{
                    fromId: this.replyMessage.fromId,
                    sendName: this.replyMessage.sendName,
                    toId: this.replyMessage.toId,
                    message: this.replyMessage.content,
                    type: '健康咨询'
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '留言回复成功'});
                        this.messagePageNum = 1
                        this.getMessageUser()
                    }else {
                        this.$Notice.error({title:'留言回复失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            getMessageByUser () {
                if (this.replyMessage.toId == null || this.replyMessage.toId === ''){
                    return this.$Message.warning('请先选择患者');
                }
                this.handleLoading = true
                    this.$http.post('message/getMessageListByUser',{
                    userId: this.replyMessage.toId,
                    pageSize: this.messagePageSize,
                    pageNum: this.messagePageNum,
                    type: '健康咨询'
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data.list) {
                            // 按时间升序排序
                            msg.data.list.sort((a, b) => {
                                return a.createTime < b.createTime ? -1 : 1
                            })
                            // 如果pageNum >1,则把返回值拼在当前messageList的前面
                            if (this.messagePageNum > 1) {
                                this.messageList = msg.data.list.concat( this.messageList)
                            } else {
                                this.messageList = msg.data.list
                                this.$nextTick(() =>{
                                  let div = document.getElementById('messageContent')
                                  console.log('messageContent: ', div.scrollHeight)
                                  div.scrollTop = div.scrollHeight
                                })
                            }
                        }
                        this.messagePages = msg.data.pages
                        this.messagePageNum +=1
                    }else {
                        this.$Notice.error({title:'留言获取失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
                this.getMessageByUser()
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
    .info_backgroup{
        background-image: url('../../assets/image/phone.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        height: 630px;
        padding: 80px 110px 85px 115px;
    }

    .info_html{
        max-height:433px;
        height:433px;
        padding-top: 5px;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 5px;
    }

    .my_complete{
        line-height: 20px;
        color: #2d8cf0;
        cursor: pointer;
    }
</style>


